import { render, staticRenderFns } from "./ActGeometry__loadCoords.vue?vue&type=template&id=1cd6ba7e&scoped=true&"
import script from "./ActGeometry__loadCoords.vue?vue&type=script&lang=js&"
export * from "./ActGeometry__loadCoords.vue?vue&type=script&lang=js&"
import style0 from "./ActGeometry__loadCoords.vue?vue&type=style&index=0&id=1cd6ba7e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cd6ba7e",
  null
  
)

export default component.exports